// pt_PT language file
// Generated from Feishu Bitable
// Total entries: 465

export default{
    "game_diamond": {
        "title": "Info sobre Diamantes de Jogo",
        "title0_title": "Como conseguir Diamantes de Jogo",
        "title0": {
            "txt1": "1. Ganhe em tarefas ou eventos específicos.",
            "txt2": "2. Não podem ser comprados com recarga."
        },
        "title1_title": "Uso dos Diamantes de Jogo",
        "title1": {
            "txt1": "1. Apenas para jogar.",
            "txt2": "2. No jogo, os Diamantes de Jogo valem como diamantes normais e podem ser usados direto. Diamantes ganhos com Diamantes de Jogo são normais.",
            "txt3": "3. Diamantes de jogo são usados primeiro.",
            "txt4": "4. Pode ser combinado com diamantes. Ex: 200 + 800 usados juntos."
        },
        "title2_title": "Validade dos Diamantes de Jogo",
        "title2": {
            "txt1": "1. Valem por tempo limitado e serão recolhidos ao expirar."
        }
    },
    "guanxi_gift_rule_title": "Descrições do presente",
    "guanxi_gift_rule_1": "Após enviar um presente de relacionamento, o destinatário pode escolher se quer formar um relacionamento com você. Somente um relacionamento pode existir entre duas pessoas de cada vez.",
    "guanxi_gift_rule_2": "Cada pessoa pode ter até 3 relacionamentos, e os tipos de relacionamento podem ser os mesmos.",
    "guanxi_gift_rule_3": "Você pode encerrar um relacionamento 24 horas após formá-lo. Após terminar um relacionamento, você pode formar um novo após mais 24 horas.",
    "not_exist": "Não encontrado",
    "mbti_intro_title": "Descrições MBTI",
    "mbti_intro_pers": "Traços de Personalidade",
    "mbti_intro_love": "Traços Românticos",
    "mbti_intro_istj_pers": "Personalidade do Inspetor",
    "mbti_intro_istj_feature": "Sérios, quietos, orientados aos detalhes e precisos, preferem uma vida ordenada e estruturada. Confiáveis e responsáveis, seguem regras e tradições.",
    "mbti_intro_istj_love": "No amor, os ISTJs são parceiros leais e estáveis. Levam os relacionamentos a sério, focando no compromisso e na responsabilidade, demonstrando cuidado por meio de ações em vez de palavras, e precisam de tempo para formar conexões profundas.",
    "mbti_intro_isfj_pers": "Personalidade Cuidadora",
    "mbti_intro_isfj_feature": "Gentis, bondosos e empáticos, são atenciosos e pacientes com as necessidades dos outros. Detalhistas, são ótimos ouvintes e apoiadores.",
    "mbti_intro_isfj_love": "Em relacionamentos, os ISFJs são muito cuidadosos, atentos aos detalhes da vida do parceiro e criam uma atmosfera aconchegante. Costumam ser tradicionais e podem demorar a se comprometer, mas são extremamente leais quando o fazem.",
    "mbti_intro_infj_pers": "Personalidade Arquiteta",
    "mbti_intro_infj_feature": "Perspicazes e criativos, com profundo entendimento da humanidade e do futuro. Têm uma vida interior rica e são reflexivos e analíticos.",
    "mbti_intro_infj_love": "Os INFJs buscam conexão mental e emocional com seus parceiros, valorizando conversas profundas. Têm ideais elevados no amor e, quando amam, são focados e dedicados.",
    "mbti_intro_intj_pers": "Personalidade Comandante",
    "mbti_intro_intj_feature": "Lógicos, calmos e confiantes, com habilidades analíticas e de tomada de decisão fortes, valorizam o conhecimento e a sabedoria e perseguem seus objetivos com tenacidade.",
    "mbti_intro_intj_love": "Nos relacionamentos, os INTJs abordam o amor de maneira racional, valorizando crenças e objetivos compartilhados. Embora reservados emocionalmente, mostram cuidado através de ações pensadas.",
    "mbti_intro_istp_pers": "Personalidade Artesã",
    "mbti_intro_istp_feature": "Prático, observador e analítico, gosta de tarefas práticas e de resolver problemas, especialmente em áreas mecânicas ou técnicas.",
    "mbti_intro_istp_love": "ISTPs são espontâneos e livres em relacionamentos, aproveitando o momento presente com seus parceiros e compartilhando os prazeres da vida sem restrições.",
    "mbti_intro_isfp_pers": "Personalidade Artista",
    "mbti_intro_isfp_feature": "Sensíveis, gentis e artísticos, priorizam experiências emocionais e sensoriais, frequentemente se expressando por formas criativas.",
    "mbti_intro_isfp_love": "Em relacionamentos, os ISFPs são românticos e atenciosos, habilidosos em criar uma atmosfera encantadora, e costumam surpreender seus parceiros. Podem ser emocionais e precisam de um parceiro que os compreenda e apoie.",
    "mbti_intro_infp_pers": "Personalidade Mediadora",
    "mbti_intro_infp_feature": "Idealistas, gentis e empáticos, têm uma vida interior rica e uma forte compreensão da natureza humana, valorizando harmonia e beleza.",
    "mbti_intro_infp_love": "INFPs investem profundamente em relacionamentos, buscando conexões emocionais fortes. Valorizam trocas emocionais e compartilham uma visão esperançosa do amor.",
    "mbti_intro_intp_pers": "Personalidade Lógica",
    "mbti_intro_intp_feature": "Analíticos e curiosos, têm um forte desejo de conhecimento, explorando áreas desconhecidas em busca da verdade.",
    "mbti_intro_intp_love": "Nos relacionamentos, os INTPs são lógicos, focando na compatibilidade intelectual e emocional. Podem ser reservados ao expressar sentimentos, mas usam discussões para fomentar o entendimento mútuo.",
    "mbti_intro_estp_pers": "Personalidade Empreendedora",
    "mbti_intro_estp_feature": "Energéticos, extrovertidos e aventureiros, gostam de interações sociais e de assumir riscos, aproveitando as oportunidades ativamente.",
    "mbti_intro_estp_love": "Em relacionamentos, os ESTPs são vibrantes e apaixonados, adorando explorar novas experiências com seus parceiros. São diretos e expressam seus pensamentos e sentimentos abertamente.",
    "mbti_intro_esfp_pers": "Personalidade Artista",
    "mbti_intro_esfp_feature": "Extrovertidos, otimistas e expressivos, gostam de socializar e de entretenimento, trazendo energia e entusiasmo.",
    "mbti_intro_esfp_love": "No amor, os ESFPs são parceiros animados que gostam de atividades sociais compartilhadas, focando nos sentimentos do presente e trazendo alegria e emoção aos parceiros.",
    "mbti_intro_enfp_pers": "Personalidade Defensora",
    "mbti_intro_enfp_feature": "Criativos, energéticos e calorosos, gostam de interagir com os outros e entendem profundamente as emoções alheias.",
    "mbti_intro_enfp_love": "Os ENFPs são como o sol nos relacionamentos, trazendo calor e alegria para seus parceiros. Cheios de romance, expressam seu amor ativamente e esperam criar lindas memórias juntos.",
    "mbti_intro_entp_pers": "Personalidade Debatedora",
    "mbti_intro_entp_feature": "Inteligentes, espirituosos e curiosos, gostam de debater e explorar novas ideias e assuntos.",
    "mbti_intro_entp_love": "Os ENTPs envolvem-se em discussões profundas e debates com parceiros, aproveitando o desafio e o crescimento intelectual no amor. Geralmente brincalhões, trazem humor ao relacionamento.",
    "mbti_intro_estj_pers": "Personalidade Executiva",
    "mbti_intro_estj_feature": "Práticos, decididos e confiantes, com fortes habilidades de organização e liderança, priorizam a eficiência e os resultados.",
    "mbti_intro_estj_love": "No amor, os ESTJs são assertivos e determinados, perseguindo ativamente seus interesses e planejando para o futuro. Mostram afeto através de apoio prático e ações.",
    "mbti_intro_esfj_pers": "Personalidade Consular",
    "mbti_intro_esfj_feature": "Amigáveis e calorosos, são sociáveis e cuidadosos com os outros, valorizando a tradição e os laços familiares.",
    "mbti_intro_esfj_love": "Os ESFJs são parceiros atenciosos e cuidadosos, criando um ambiente romântico e caloroso. Frequentemente tradicionais, apreciam os costumes de namoro familiares e a aprovação da família.",
    "mbti_intro_enfj_pers": "Personalidade Protagonista",
    "mbti_intro_enfj_feature": "Carismáticos e confiantes, conectam-se facilmente e comunicam-se bem, entendendo e orientando os outros de forma eficaz.",
    "mbti_intro_enfj_love": "Os ENFJs são parceiros entusiasmados e românticos, expressando seu amor abertamente e criando uma atmosfera calorosa. Valorizam o intercâmbio emocional e buscam formar um vínculo profundo com seus parceiros.",
    "mbti_intro_entj_pers": "Personalidade Executiva",
    "mbti_intro_entj_feature": "Lógicos, confiantes e determinados, com fortes habilidades de liderança e tomada de decisão, valorizam a excelência e o sucesso, estabelecendo altos padrões para si e para os outros.",
    "mbti_intro_entj_love": "No amor, os ENTJs são orientados por metas, escolhendo parceiros com ideias semelhantes que apoiam o crescimento mútuo. Priorizam a competência e as ambições compartilhadas, aprofundando os relacionamentos por meio de objetivos comuns.",
    "expressProposalWall": "Amor Mural",
    "expressHowTo": "Como aparecer no Amor Mural",
    "expressSend": "Envie o presente de Confissão para seu amor e seu texto de amor aparecerá no Amor Mural",
    "expressSend1": "1. Toque em \"Confessar Agora\", você pode ir para a festa e selecionar o usuário para enviar suas palavras de amor.",
    "expressSend2": "2. Selecione o presente e insira as palavras que você quer dizer a ele/ela no cartão.",
    "expressSend3": "3. Toque para enviar o presente e seu Confissão será exibido no mural.",
    "expressDifferent": "Tipos de Presentes de Confissão",
    "expressWeHave": "Temos 4 tipos de Presentes",
    "expressWeHave1": "1. Básico: Fundo de cor simples.",
    "expressWeHave2": "2. Decorado: Fundo colorido decorativo.",
    "expressWeHave3": "3. Luxuosa: Fundo decorativo com efeito de luxo.",
    "expressWeHave4": "4. Top: Fundo decorativo com efeito de luxo e com barra de notificação em todo o servidor.",
    "expressProposal": "Alcance de Exibição do Cartão de Amor",
    "expressProposal1": "1. Amor Mural na sala. (Toque na barra acima dos presentes de amor)",
    "expressProposal2": "2.Amor Mural ao lado da página de Momentos.",
    "diamondDrop1": "1. Quando um usuário envia presentes com valor totalizando mais de 50.000 diamantes por uma vez na sala (presente de sorte será contados 10%), uma caixa de baú caiá na sala, todos os usuários podem abrir a baixa para pegar diamantes.",
    "diamondDrop2": "2. Cada baú tem uma contagem regressiva de 1 minuto antes de poder ser aberto.",
    "diamondDrop3": "3. Os diamantes em cada baú são limitados; quando a contagem regressiva termina, você não pode mais reivindicar diamantes daquele baú.",
    "diamondDrop4": "4. Após o baú ser fechado, você pode clicar para ver quantos diamantes você consegue dele.",
    "baoxaingxianding": "宝箱限定",
    "cancelAccount": {
        "accountRecoveryContent": "Durante o período de recuperação, você pode fazer login novamente usando seu método anterior e escolher recuperar sua conta. Uma vez recuperada, você recuperará todas as suas mensagens, níveis e diamantes da conta.",
        "accountRecoveryTitle": "Recuperação de Conta:",
        "confirmCancellation": "Tem certeza de que deseja excluir?",
        "convalescenceContent": "Após enviar um pedido de exclusão, sua conta será desativada temporariamente por 30 dias. Durante esse período, todas as informações da sua conta, níveis e diamantes serão retidos, permitindo uma recuperação perfeita se você mudar de ideia.",
        "convalescenceTitle": "Período de Recuperação:",
        "finalContent": "Se você não escolher recuperar sua conta até o final do período de recuperação (31 dias a partir do pedido de exclusão), sua conta e todos os dados associados serão excluídos permanentemente. Observe que, uma vez excluída, sua conta e dados não podem ser recuperados.",
        "finalTitle": "Exclusão Final:",
        "reserveContent": "Durante o período de recuperação, protegeremos os dados da sua conta para garantir que não sejam perdidos ou danificados.",
        "reserveTitle": "Retenção de Dados:",
        "statementContent": "Solicitação de Exclusão: Após enviar uma solicitação de exclusão de conta, sua conta entrará em um “período de recuperação” de 30 dias. Durante esse período, você pode optar por recuperar sua conta a qualquer momento. Se você fizer parte de uma agência, a exclusão da conta não será possível.",
        "statementTitle": "Aviso de Exclusão de Conta:",
        "userContent": "Obrigado por usar nossos serviços. Entendemos que às vezes você pode precisar excluir sua conta. Para garantir que sua decisão seja bem considerada e para fornecer uma oportunidade de reconsideração, delineamos aqui o processo de exclusão de conta e os termos relacionados.",
        "userTitle": "Prezado Usuário:"
    },
    "Countdown": "倒计时",
    "Endactivity": "Evento Encerrado",
    "eventDetails": "Detalhes do Evento",
    "eventGifts": "Presentes do Evento",
    "eventList": "Ranking do Evento",
    "eventReward": "Recompensas do Evento",
    "eventRewards": {
        "player": "Jogadores Ativos Diários",
        "proportion": "Taxa de Retorno de Prêmios",
        "title": "Prêmios do Evento",
        "txt1": "1. Os dados do dia anterior são calculados diariamente às 00:00 (UTC+8).",
        "txt2": "2. Os prêmios são concedidos com base no número de participantes e nos diamantes realmente gastos na sala (apostas dos usuários menos ganhos dos usuários).",
        "txt3": "3. Os dados da semana anterior são calculados toda segunda-feira às 00:00 (UTC+8), e as recompensas são distribuídas dentro de 3 dias.",
        "txt4": "4. Taxa de Retorno de Prêmios:",
        "txt5": "5. Definição de Jogador Ativo: Um jogador que aposta mais de 1.000 diamantes em um dia."
    },
    "EventRules": "Regras do Evento",
    "Eventtime": "Tempo do Evento",
    "guild": {
        "guild_certification01": "Verificação de Agência",
        "guild_certification02": "Bem-vindo, Agência",
        "guild_certification03": "Requisitos de Recrutamento",
        "guild_certification04": [
            "Tem 10 hosts contratados em uma semana",
            "Capaz de fornecer a identidade do líder da agência e outros documentos com nome real",
            "Forneça um perfil da agência, introdução da equipe, informações dos apresentadores, regras de ganhos dos apresentadores, etc."
        ],
        "guild_certification05": "Se você atender aos requisitos acima, envie suas informações para o e-mail oficial: billionairepte@gmail.comUma vez aprovado, um membro da equipe entrará em contato com você.",
        "guild_certification06": "Copiado para a área de transferência",
        "guild_certification07": "Contato para Consultas",
        "guild_certification08": "Copiar",
        "guild_certification09": "Informações de Associação",
        "guild_certification10": [
            {
                "title": "1. Regras de Associação",
                "value": [
                    "Os candidatos devem concordar com o líder da agência para iniciar uma solicitação de associação na plataforma. Uma vez aprovado pelo líder, eles se tornam âncoras assinados, contribuindo para a agência."
                ]
            },
            {
                "title": "2. Regras de Rescisão",
                "value": [
                    "Para sair da agência após ingressar, o apresentador precisa concordar com o líder da agência. Clique em \"Sair da Agência\" na página de perfil da agência. O líder da agência deve clicar em \"Concordar em Sair\" e então o membro sairá da agência.",
                    "Após a retirada ser bem-sucedida, você pode se inscrever para ingressar em outra agência."
                ]
            }
        ],
        "guild_certification11": "Informações da Agência",
        "guild_certification12": [
            {
                "title": "Ganhos da Agência",
                "value": [
                    "Usuários e âncoras em salas familiares recebem presentes, gerando contribuições para a agência.",
                    "Ataques de chefe ocorrem em salas familiares.",
                    "Âncoras assinadas com a agência criam salas CP, e receber presentes gera contribuições para a agência. (Âncoras não assinadas não podem criar salas CP e gerar contribuições para a família após ingressar na família.)"
                ]
            }
        ],
        "InvitationCodeTitle": "Código de Convite",
        "invite_rules_intriduction": "Regras de Convite",
        "invite_rules_intriduction_content": [
            "Âncoras podem se inscrever para ingressar em sua agência e se tornar âncoras inserindo o código de convite durante o registro.",
            "Âncoras que não inseriram um código de convite durante o registro podem se inscrever para ingressar em sua família através da página da família e, em seguida, se inscrever para se tornar âncoras."
        ]
    },
    "legend": {
        "title": "Fevereiro Lendário"
    },
    "officialMember": "Equipe Oficial",
    "prettyNumber": {
        "text": "Ⅰ. Coleta de ID Especial",
        "text1": "Após alcançar o Nível Nobre 3 ou superior, você pode reivindicar um ID Especial correspondente ao seu nível.",
        "text2": "Nobres de nível superior podem reivindicar um ID Especial de nível inferior. Por exemplo, um Nobre 6 pode reivindicar um ID Especial de Nível 3.",
        "text3": "Quando seu status de nobre expira, o ID Especial também se torna indisponível. Você precisa reativar seu nobre para continuar usando o ID Especial.",
        "text5": "Depois de reivindicar um ID Especial, você não pode trocá-lo por outro número do mesmo nível ou inferior.",
        "text6": "Se você alcançar um nível nobre superior enquanto usa um ID Especial, poderá mudar imediatamente para um ID Especial de nível superior, e o ID original retornará à loja.",
        "text7": "Por exemplo, um usuário Nobre 4 que inicialmente reivindica um ID Especial Nobre 4 e depois atualiza para Nobre 6 não pode trocar para um ID Especial Nobre 4 ou inferior, mas pode reivindicar imediatamente um ID Especial Nobre 6.",
        "title": "Explicação",
        "title1": "Ⅱ. Expiração do ID Especial",
        "title2": "Ⅲ. Substituição do ID Especial"
    },
    "reception": {
        "reception01": "Explicação do Ranking de Presentes",
        "reception02": [
            {
                "title": "O que é o Ranking de Presentes da Sala?",
                "value": [
                    "O Ranking de Presentes da Sala é uma classificação em tempo real dos presentes recebidos na sala",
                    "Contagem de presentes da sala = Contagem de presentes em diamantes"
                ]
            },
            {
                "title": "Como é classificado o Ranking de Presentes da Sala?",
                "value": [
                    "A classificação é determinada com base na renda total de todas as salas, calculada de forma abrangente",
                    "Ranking por Hora: Reinicia a cada hora em UMT+8",
                    "Ranking Diário: Reinicia às 00:00 UMT+8 todos os dias"
                ]
            },
            {
                "title": "O Top 1 no Ranking por Hora é transmitido para todo o servidor",
                "value": [
                    "A sala Top 1 no ranking de presentes por hora é anunciada em todas as salas do servidor"
                ]
            }
        ]
    },
    "roomParty": {
        "back": "Voltar",
        "event_rule": "<p>1. Ranking de Duração: Acompanha o tempo total que os usuários passam em todas as posições de microfone da sala durante o evento. Os 3 principais contribuintes nas 3 principais salas receberão recompensas.</p><p>2. Ranking de Generosidade: Acompanha o número total de diamantes recebidos na sala durante o evento. Os 3 maiores gastadores de diamantes nas 3 principais salas receberão recompensas.</p><p>3. Este evento é um evento de ciclo semanal, com o ranking sendo redefinido e recalculado a cada semana.</p>",
        "last_week": "Semana Passada",
        "last_week_rank": "Detalhes do Ranking da Semana Passada",
        "reward": "Recompensas",
        "rich_rank": "Ranking de Presentes da Sala",
        "rule": "Regras",
        "rule_reward": "Regras e Recompensas",
        "time_rank": "Ranking de Duração",
        "title": "Sala da Família",
        "top1": "TOP1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_1_name": "頭像框14天",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/mount/thunder_armor.png?t=1666610955",
        "top1_pictures_2_name": "入場特效14天",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_3_name": "頭像框14天",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_4_name": "頭像框7天",
        "top2": "TOP2",
        "top3": "TOP3"
    },
    "TopUpRewards": "Recompensas de Recarga",
    "treasure_chest": {
        "title": "Instruções de Presentes do Baú do Tesouro",
        "value1": "Existem três tipos de baús do tesouro: Madeira, Prata e Ouro.",
        "value2": "Ao abrir um baú do tesouro, você receberá aleatoriamente um presente do baú e o enviará.",
        "value3": "O remetente ganha pontos de experiência com base nos diamantes gastos, enquanto o destinatário recebe Moedas e pontos de charme com base no valor do presente do baú.",
        "value4": "Baú de Madeira, com preço de 1500 diamantes, contém os seguintes presentes:",
        "value5": "Baú de Prata, com preço de 7500 diamantes, contém os seguintes presentes:",
        "value6": "Baú de Ouro, com preço de 25000 diamantes, contém os seguintes presentes:",
        "value7": "Os presentes do baú do tesouro são apenas para entretenimento e interação social. Qualquer ação que afete a justiça ou explore falhas do produto será proibida. Se detectado, a plataforma banirá a conta e se reserva o direito de tomar medidas legais."
    },
    "treasure_name": {
        "name1": "Baú de Madeira",
        "name2": "Baú de Prata",
        "name3": "Baú de Ouro",
        "name4": "Probabilidade"
    },
    "Value": "Valor:",
    "Webname": {
        "addUid": "Adicionar UID",
        "balance": "Saldo:",
        "Confirm": "Confirmar",
        "err_uid": "UID inválido, por favor insira novamente",
        "lang": "Selecionar Idioma",
        "Query": "Pesquisar",
        "recharge": "Centro de Recarga",
        "Recharge": "Recarga",
        "self": "Canal",
        "uid": "Alterar UID",
        "uuserName": "Apelido:",
        "Withdrawal": "Sacar"
    },
    "Weekly_Cp": {
        "7days": "7 dias",
        "back": "Voltar",
        "countdown": "Contagem regressiva",
        "day": "Dias",
        "diamonds": "https://image.pocketliveapp.com/image/activity/New%20Folder/diamonds.png",
        "event_rule": "<p>Notas</p><p>1. Todas as recompensas serão creditadas na sua conta dentro de 3-5 dias úteis após o término do evento.</p><p>2. O ranking calcula os diamantes gastos no envio de presentes do evento para outros usuários. 1 diamante = 1 ponto CP, e os 3 principais pares de CP com mais pontos CP receberão recompensas do evento.</p><p>3. O evento termina toda segunda-feira às 00:00 (UTC+8), e os valores da semana anterior são ajustados.</p><p>4. Apenas 10% dos diamantes gastos em presentes de sorte serão contados.</p>",
        "gift": "Presentes do Evento",
        "hour": "Hora",
        "last_week": "Semana passada",
        "last_week_rank": "Lista da semana passada",
        "minute": "Minuto",
        "pocketcoins": "https://image.pocketliveapp.com/image/activity/New%20Folder/coins.png",
        "reward": "Recompensas",
        "rule": "Regras",
        "rule_reward": "Regras e Recompensas",
        "seconds": "Segundos",
        "title": "Alma Gêmea",
        "top1": "Primeiro",
        "top1_pictures_1": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top1_pictures_1_name": "Moldura de Avatar Estrela da Semana",
        "top1_pictures_2": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top1_pictures_2_name": "Moldura de Avatar de Melhor Suporte",
        "top1_pictures_3": "https://cos.koudailive.com/image/goods/2011_cloth_female.png?t=1678879041",
        "top1_pictures_34_name": "Traje de Estrela da Semana",
        "top1_pictures_4": "https://cos.koudailive.com/image/goods/2010_suit_male.png?t=1678879038",
        "top2": "TOP2",
        "top2_pictures_1": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top2_pictures_2": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top3": "TOP3",
        "top3_pictures_1": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top3_pictures_2": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top46": "TOP 4-6",
        "top710": "TOP 7-10"
    },
    "Withdrawal": "Instruções de Retirada",
    "withdrawalInstructions": {
        "text1": "O recurso de retirada está disponível atualmente apenas em países selecionados.",
        "text2": "O tempo para processar retiradas pode variar dependendo do canal.",
        "text3": "O valor real recebido pode ser ligeiramente inferior ao valor exibido devido a flutuações da taxa de câmbio e taxas.",
        "text4": "Você só pode retirar uma vez por dia.",
        "text5": "Se você encontrar algum problema, por favor, entre em contato conosco."
    },
    "withdrawalLogin": {
        "accountId": "Chave Pix",
        "accountIdTips": "Somente Número",
        "accountIdtsa": "Chave Pix não pode estar vazio",
        "accountType": "Tipo de Chave Pix",
        "code": "Código de verificação:",
        "Confirm": "Confirmar",
        "documentId": "Número de identificação pessoal",
        "documentIdTips": "Somente Número",
        "documentIdtsa": "O tipo de ID não pode estar vazio",
        "documentType": "Tipo de identificação",
        "getAccount": "Obter conta",
        "getUserId": "Por favor, insira o ID do usuário",
        "incorrectAccount": "Conta incorreta",
        "login": "Entrar",
        "loginSuccessful": "Login bem-sucedido",
        "name": "Nome Completo",
        "nameTips": "Nome Completo",
        "nametsa": "O comprimento deve estar entre 5 e 100 caracteres",
        "officialGroup": "Se tiver alguma dúvida, entre em contato com o suporte oficial",
        "pocket": "Saldo de Pocket Coin",
        "Pocket": "Saldo insuficiente de Pocket Coin",
        "Send": "Enviar",
        "text": "O código de verificação será enviado dentro do aplicativo",
        "title": "Retirada de ganhos",
        "title2": "Detalhes de retirada",
        "user_id": "ID da Conta:",
        "Whatsapp": "Conta do Whatsapp incorreta",
        "WhatsappTips": "Somente Número",
        "applicationTime": "Data da Solicitação",
        "amount": "Valor do Saque",
        "success": "Sucesso",
        "applicationSuccess": "Solicitação Enviada"
    },
    "top1AnchorRewards": "Recompensa para o Âncora Top 1",
    "top2_3AnchorRewards": "Recompensas para os Âncoras Top 2-3",
    "top4_10AnchorRewards": "Recompensas para os Âncoras Top 4-10",
    "top1Icon7day": "Moldura de Avatar *7 Dias",
    "top1_2Icon7day": "Efeito de Entrada *7 Dias",
    "top3Icon7day": "Moldura de Avatar *7 Dias",
    "top1VIPRewards": "Prêmio VIP dos 1 melhores",
    "top2_3VIPRewards": "2-3 principais prêmios VIP",
    "top4_10VIPRewards": "4-10 principais prêmios VIP",
    "relastionship": {
        "des": [
            "",
            "1. Após enviar um presente de relacionamento, a outra pessoa pode escolher se deseja estabelecer um relacionamento com você. Só pode existir um tipo de relacionamento entre duas pessoas.",
            "2. Dentro de 7 dias corridos (UTC+3) após estabelecer o relacionamento, o nível de intimidade não diminui. Após o período de proteção, se a intimidade não aumentar 50 pontos em um dia, ela diminuirá 10% à meia-noite do dia seguinte (mínimo 1). Quando a intimidade chegar a 0, o relacionamento será desfeito à meia-noite. Se não houver aumento de 50 pontos em 10 dias seguidos, o relacionamento termina automaticamente.",
            "3. Você pode encerrar o relacionamento após 24 horas de formá-lo. Após encerrá-lo, pode reatar após 24 horas.",
            "4. Cada pessoa tem 3 vagas de relacionamento por padrão. Você pode gastar diamantes para comprar mais, cada vaga custa 99.999 diamantes, e é possível comprar até 10. Você também pode aumentar as vagas elevando o nível VIP.",
            "Nível VIP",
            "Total de espaços de relacionamento expansíveis"
        ]
    },
    "gift_album_des1": "Enviar os presentes acima pode ajudá-lo/ajudá-la a iluminar o Álbum Semanal - \"Volta ao Mundo\" e ganhar recompensas.",
    "gift_album_des2": "Enviar os presentes acima pode ajudá-lo/ajudá-la a iluminar o Álbum Permanente - \"Foco de Paixão\" e ganhar recompensas.",
    "gift_album_des3": "Enviar os presentes acima pode ajudá-lo/ajudá-la a iluminar o Álbum Permanente - \"Guarda SVIP\" e ganhar recompensas.",
    "gift_album_des4": "Enviar os presentes acima pode ajudá-lo/ajudá-la a iluminar o Álbum Permanente - \"Casamento dos Sonhos\" e ganhar recompensas.",
    "gift_album_des5": "Vá para [Perfil] - [Mural de Presentes] - [Álbum] para ver detalhes",
    "gift_album_des8": "Enviar os presentes acima pode ajudar ele/ela a desbloquear o catálogo permanente – 'Festa de Aniversário' e receber recompensas.",
    "gift_album_des7": "Enviar os presentes acima pode ajudá-lo/ajudá-la a iluminar o Álbum Permanente - \"Estrela da Sala\" e ganhar recompensas.",
    "gift_harifata": "Burj Khalifa",
    "gift_sailing_hotel": "Burj Al Arab",
    "gift_mosque": "a grande Mesquita",
    "gift_abatta": "Torre Abate",
    "gift_sphinx": "Esfinge",
    "svip_gift_1": "SVIP1",
    "svip_gift_2": "SVIP2",
    "svip_gift_3": "SVIP3",
    "svip_gift_4": "SVIP4",
    "svip_gift_5": "SVIP5",
    "svip_gift_6": "SVIP6",
    "gift_conf_lv1": "Heartbeat",
    "gift_conf_lv2": "Love Struck",
    "gift_conf_lv3": "Amor Eterno",
    "gift_conf_lv4": "Único Amor",
    "gift_habibi": "Amigo",
    "gift_bestie": "Amiga",
    "gift_couple": "Noviazgo",
    "gift_confidant": "íntimo",
    "weding_gift_kiss": "Beijo",
    "weding_gift_ring": "Anel",
    "weding_gift_proposal": "Pedido de casamento",
    "weding_gift_castle": "Castelo",
    "weding_gift_wedding_dress": "Vestido de noiva",
    "weding_gift_wedding": "Casamento",
    "gift_album_des6": "Regras",
    "guild_can_with": "Disponível",
    "guild_with_ing": "Processando",
    "guild_self_withdraw": "Saque próprio",
    "guild_transfer_to_leader": "Transferir para Líder da Agência",
    "guild_salary_to_reseller": "Transferir para Revendedor",
    "guild_convert_to_diamond": "Converter para Diamantes",
    "guild_platform_settlement": "Liquidação da Plataforma",
    "guild_withdrawal_records": "Histórico de Saques",
    "guild_current_withdrawable_pcoin": "Coins disponíveis",
    "guild_transfer_pcoin_amount": "Valor para transferir",
    "guild_all": "Todos",
    "guild_read_before_withdraw": "Leia antes de sacar:",
    "guild_withdraw_note_1": "Enviar",
    "guild_withdraw_note_2": "Coins insuficientes para saque",
    "guild_min_withdraw_amount": "Confirmar envio?",
    "guild_withdraw_note_4": "Cancelar",
    "guild_appeal_to_platform": "Confirmar",
    "guild_submit_application": "Método de Saque",
    "guild_withdraw_below_min": "Saque do Líder",
    "guild_confirm_submit_application": "Hora da solicitação",
    "guild_freeze_notice": "Tempo de processamento",
    "guild_communicate_with_leader": "Motivo da recusa",
    "guild_cancel": "Valor reembolsado",
    "guild_confirm": "Pendente",
    "guild_withdrawal_method": "Concluído",
    "guild_leader_withdraw": "Recusado",
    "guild_status_timeout_rejected": "Recusado automaticamente (tempo esgotado)",
    "guild_status_unknown": "Desconhecido",
    "guild_status_platform_review": "Em análise (Plataforma)",
    "guild_status_guild_review": "Em análise (Agência)",
    "guild_status_timeout_rejected_2": "Tempo esgotado (Devolvido)",
    "guild_status_platform_rejected": "Recusado pela plataforma",
    "guild_status_guild_leader_approval": "Repasse à Agência em <span>{n}</span>h",
    "guild_apply_time": "Apenas últimos 3 meses",
    "guild_process_time": "Dúvidas sobre saque?",
    "guild_rejection_reason": "Falar com Suporte",
    "guild_amount_refunded": "Revendedor verificado",
    "guild_status_pending": "Apenas para revendedores",
    "guild_status_completed": "Disponível",
    "guild_status_rejected": "Valor da transferência",
    "guild_show_last_3_months": "Chegada estimada",
    "guild_withdrawal_question": "Sucesso",
    "guild_contact_customer_service": "Converter para Diamantes",
    "guild_certified_reseller": "Coins disponíveis para conversão",
    "guild_not_reseller_cannot_transfer": "Converter",
    "guild_current_withdrawable": "Convertido",
    "guild_transfer_amount": "Coin liquidado",
    "guild_estimated_arrival": "Solicitação enviada",
    "guild_read_before_operation": "1. Confirme com o revendedor os detalhes do pagamento offline com antecedência",
    "guild_transfer_note_1": "2. Transferências apenas para revendedor",
    "guild_transfer_note_2": "Confirmar transferência",
    "guild_confirm_transfer": "Confirmar envio?",
    "guild_confirm_submit_transfer": "{n} moedas serão descontadas",
    "guild_deduct_pcoin_receive_diamond": "Combine os detalhes do pagamento com o revendedor",
    "guild_communicate_with_reseller": "Transação bem-sucedida",
    "guild_operation_success": "Converter para Diamantes",
    "guild_exchange_diamond": "Coins disponíveis para conversão",
    "guild_current_exchangeable_pcoin": "Converter",
    "guild_exchange": "Conversão concluída",
    "guild_exchange_success": "Coins a liquidar",
    "guild_settlement_pcoin_amount": "1. Confirme com a equipe de Operações o método de saque com antecedência",
    "guild_settlement_note_1": "2. Pagamentos serão processados na próxima segunda-feira",
    "guild_settlement_note_2": "3. Saque mínimo: {n} Coins",
    "guild_settlement_min_amount": "Solicitação enviada",
    "guild_application_submitted": "{n} Coins serão descontadas",
    "guild_deduct_pcoin": "Combine os detalhes do pagamento com a equipe de Operações",
    "guild_user_not": "Usuário não encontrado",
    "guild_please_enter_amount": "Insira o valor",
    "guild_insufficient_balance": "Saldo insuficiente",
    "guild_please_enter_reseller_uid": "Insira o UID do RESELLER",
    "guild_please_search_reseller_first": "Pesquise o RESELLER primeiro",
    "guild_select_hand": "Selecione uma ação",
    "guild_ci_hand": "1. Esta ação enviará uma solicitação ao Líder da Guilda,",
    "guild_offline_transfer_funds": "e o pagamento será feito offline pelo líder",
    "guild_ci_hand_2": "2. Confirme antecipadamente o método de pagamento com o líder (cartão bancário / USDT, etc.)",
    "guild_ci_hand_3": "3. O valor mínimo de saque é {n} Coins",
    "guild_ci_hand_4": "4. Se o líder confirmar o pagamento e você não receber, mantenha os registros de chat e",
    "guild_ci_hand_5": "envie uma contestação à plataforma",
    "guild_ci_hand_6": "O sistema congelará {n} Coins até o líder processar",
    "guild_ci_hand_7": "Confirme o canal de saque com o líder; o pagamento é offline",
    "guild_tips_1": "Coins disponíveis abaixo do mínimo",
    "guild_contact_service": "Entre em contato com a equipe de operações para organizar o pagamento",
    "guild_reseller_tips": "Suas moedas viraram diamantes do outro usuário. Fale com ele sobre o pagamento.",
    "gift_collection_detail_permanent_birthday": "Festa de Aniversário",
    "gift_collection_detail_permanent_roomstar": "Estrela da Sala",
    "gift_holy_sword": "Espada Sagrada",
    "gift_volcano": "Vulcão",
    "gift_emperor_come_world": "O Sortudo Chegou",
    "gift_castle_of_love": "Castelo do Amor",
    "gift_Immortal_god_war": "Deus Imortal da Guerra",
    "gift_king_of_gods": "Rei dos Deuses",
    "birthday_gift_cybergift": "Presente Cyber",
    "birthday_gift_wish": "Desejo da Lâmpada",
    "birthday_gift_cake": "Bolo Dourado",
    "birthday_gift_lion": "Benção do Leão",
    "birthday_gift_biggift": "Presente Luxo",
    "guild_page_fee": "Taxa de $2 por saque",
    "guild_page_saudi": "Arábia Saudita",
    "guild_page_morocco": "Marrocos",
    "guild_page_bank": "Banco",
    "guild_page_name": "Nome (em inglês)",
    "guild_page_name_english": "Nome deve estar em inglês",
    "guild_page_bank_number": "Número da conta bancária",
    "guild_page_enter": "Insira um número de conta válido",
    "guild_page_address": "Endereço (em inglês)",
    "guild_page_address_english": "Endereço deve estar em inglês",
    "guild_page_country": "País/Região",
    "guild_page_holder_name": "Nome do titular da conta",
    "guild_page_sa": "Ex.: SA8200000000XXXXXXXXXXXX",
    "guild_page_format": "Formato: Rua, Área, Cidade, Estado, País",
    "guild_page_minimum": "3. O valor mínimo de saque é {n} Coins",
    "withdraw_input_amount": "Inserir valor",
    "withdraw_submit": "Sacar",
    "withdraw_quantity": "Valor do saque",
    "withdraw_actual_received": "Valor líquido recebido",
    "common_confirm": "Confirmar",
    "common_cancel": "Cancelar",
    "withdraw_error_min_amount": "Valor mínimo de saque não atingido",
    "withdraw_error_max_amount": "Excede o limite máximo de saque",
    "withdraw_error_max_p_coin": "Excede as moedas disponíveis para saque"
}
